/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CentreNotificationResponse } from '../models/centre-notification-response';
import { getNotificationNonSupprimeesByIntervenant } from '../fn/centre-notification-controller/get-notification-non-supprimees-by-intervenant';
import { GetNotificationNonSupprimeesByIntervenant$Params } from '../fn/centre-notification-controller/get-notification-non-supprimees-by-intervenant';
import { markNotificationAsDeleted } from '../fn/centre-notification-controller/mark-notification-as-deleted';
import { MarkNotificationAsDeleted$Params } from '../fn/centre-notification-controller/mark-notification-as-deleted';
import { markNotificationAsRead } from '../fn/centre-notification-controller/mark-notification-as-read';
import { MarkNotificationAsRead$Params } from '../fn/centre-notification-controller/mark-notification-as-read';

@Injectable({ providedIn: 'root' })
export class CentreNotificationControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `markNotificationAsRead()` */
  static readonly MarkNotificationAsReadPath = '/v1/centre-notification/{id_notification_intervenant}/read';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markNotificationAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  markNotificationAsRead$Response(
    params: MarkNotificationAsRead$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return markNotificationAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markNotificationAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markNotificationAsRead(params: MarkNotificationAsRead$Params, context?: HttpContext): Observable<void> {
    return this.markNotificationAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `markNotificationAsDeleted()` */
  static readonly MarkNotificationAsDeletedPath = '/v1/centre-notification/{id_notification_intervenant}/deleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markNotificationAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  markNotificationAsDeleted$Response(
    params: MarkNotificationAsDeleted$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return markNotificationAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markNotificationAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markNotificationAsDeleted(params: MarkNotificationAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.markNotificationAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getNotificationNonSupprimeesByIntervenant()` */
  static readonly GetNotificationNonSupprimeesByIntervenantPath =
    '/v1/centre-notification/{id_intervenant}/notifications-non-supprimees';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationNonSupprimeesByIntervenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationNonSupprimeesByIntervenant$Response(
    params: GetNotificationNonSupprimeesByIntervenant$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<CentreNotificationResponse>> {
    return getNotificationNonSupprimeesByIntervenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationNonSupprimeesByIntervenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationNonSupprimeesByIntervenant(
    params: GetNotificationNonSupprimeesByIntervenant$Params,
    context?: HttpContext
  ): Observable<CentreNotificationResponse> {
    return this.getNotificationNonSupprimeesByIntervenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<CentreNotificationResponse>): CentreNotificationResponse => r.body)
    );
  }
}
